import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  subHeading: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    marginRight: theme.spacing(1.125),
  },
  infoIcon: {
    color: theme.palette.icon.main,
    marginTop: theme.spacing(0.75),
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
  textField: {
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      display: 'none',
    },
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
      padding: '6px 0px 12px 0px !important',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
      color: `${theme.palette.error.main} !important`,
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  companyDetailSubHead: {
    marginBottom: theme.spacing(2),
  },
  companyDetailRow: {
    display: 'flex',
    gap: '24px',
  },

  offerDetailsRow: {
    display: 'flex',
    gap: '56px',
    flexWrap: 'wrap',
  },

  name: {
    width: '317.33px',
  },
  awsAccountId: {
    width: '650px',
    marginLeft: theme.spacing(3),
  },
  customEmailMessage: {
    marginTop: theme.spacing(6),
    width: '100%',
    marginBottom: theme.spacing(4.3),
  },
  requiredAsterisk: {
    color: theme.palette.requiredAsterisk.main,
    marginLeft: theme.spacing(0.5),
  },
  notes: {
    marginTop: theme.spacing(2),
    width: '100%',
    marginBottom: theme.spacing(4.3),
  },
  offerName: {
    width: '860.667px',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4.3),
  },
  datePicker: {
    width: '317.33px',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4.3),
  },
}))
